import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRelativeDateConfigStyles = () => {
    const theme = useTheme();

    return createSxStyles({
        link: {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: theme.typography.pxToRem(14),
        },
        // The link sits 4px below the field either way. A field with margins already draws 8px beneath itself.
        linkBelowFieldWithoutMargin: {
            marginTop: 0.5,
        },
        linkBelowFieldWithMargin: {
            marginTop: -0.5,
        },
        display: {
            cursor: "pointer",
            "& .MuiInputBase-root, & .MuiInputBase-input": {
                cursor: "pointer",
            },
        },
        backdrop: {
            zIndex: theme.zIndex.modal - 100,
        },
        popper: {
            zIndex: theme.zIndex.modal,
            width: 360,
            maxWidth: "calc(100vw - 32px)",
        },
        editor: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
            padding: theme.spacing(1.5),
            borderRadius: "10px",
        },
        row: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
        },
        value: {
            width: 72,
            flexShrink: 0,
        },
        direction: {
            width: 110,
            flexShrink: 0,
        },
        grow: {
            flex: 1,
            minWidth: 0,
        },
    });
};
